import React, { Suspense } from "react";
import { useModalState } from "./ModalStateProvider";
import { ModalRegistry } from "./ModalRegistry";
import Modal from "./Modal";

/**
 * ModalContainer dynamically renders the active modal based on the global modal state.
 * Only one modal component is mounted at a time, improving performance.
 */
const ModalContainer: React.FC = () => {
	const { modalVisible, modalProps } = useModalState();

	if (!modalVisible) return null;

	const ModalComponent = ModalRegistry[modalVisible];

	return (
		<Modal>
			<Suspense
				fallback={
					<div className="w-full h-96 flex flex-col items-center justify-center">
						<p className="animate-pulse text-primary-active">Loading...</p>
					</div>
				}
			>
				<ModalComponent {...modalProps} />
			</Suspense>
		</Modal>
	);
};

export default ModalContainer;
